module.exports = __webpack_public_path__ + "static/media/adrian_logo.e1486ec0.png";